import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  clearAll,
  clearResetBot,
  onGetCertificates,
  setCertificateDetails,
  setErrorMessageBankUser,
  setLoadingBankUser,
} from "../../../../config/redux/slice/bankUserSlice";
import { certicatesDatatable } from "../../../../helpers/dataTables";
import { postRequest } from "../../../../helpers/request";
import { appApi } from "../../../../utils/endpoints/appApi";
import { appUrls } from "../../../../utils/urls/appUrls";
import { CertificateWrapper, DataTableWrapper } from "../../../components";
import {
  setCertificateDetailsGeneral,
  setIsRefreshed,
} from "../../../../config/redux/slice/appSlice";

import CertificateFilter from "../CertificateFilter";

export default function CertificateManagement({ callEndpoint = true }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { token } = useSelector((state) => state.authData);
  const { currencies, isRefreshed } = useSelector((state) => state.app);
  const {
    bankUserSuccessMsg,
    certificateManagement: { certificatesData, newData },
  } = useSelector((state) => state.bankUser);

  useEffect(() => {
    dispatch(clearAll({}));
    dispatch(setCertificateDetails({ details: "", modal: false }));
    certicatesDatatable(
      certificatesData,
      setDetails,
      currencies,
      "certificatesTable"
    );
    getAllCertificates();
  }, []);

  useEffect(() => {
    if (isRefreshed) {
      getAllCertificates();
    }
  }, [isRefreshed]);

  const getAllCertificates = async () => {
    dispatch(clearAll({}));

    if (callEndpoint) {
      const data = {
        certificate_date: "0",
        issuer: "0",
        verification_status: "all",
      };

      await postRequest(
        token,
        `${appApi.getCertificates}`,
        data,
        dispatch,
        setLoadingBankUser,
        onGetCertificates,
        setErrorMessageBankUser
      );
      dispatch(setIsRefreshed(false));
    }
  };

  const setDetails = (data, type) => {
    dispatch(setIsRefreshed());
    dispatch(setCertificateDetails({ details: data, modal: true }));
    dispatch(setCertificateDetailsGeneral({ details: data, modal: true }));

    if (type === "view-details") {
      navigate(appUrls.bank_certificates_view);
    }
  };

  useEffect(() => {
    if (newData) {
      certicatesDatatable(
        certificatesData,
        setDetails,
        currencies,
        "certificatesTable"
      );
      dispatch(clearResetBot());
    }

    if (bankUserSuccessMsg === "Certificate Uploaded Successfully") {
      getAllCertificates();
    }
  }, [newData, bankUserSuccessMsg]);

  return (
    <CertificateWrapper>
      <CertificateFilter />

      <DataTableWrapper
        tableID="certificatesTable"
        tableName="Certificate Management"
      >
        <thead>
          <tr>
            <th>Reference ID</th>
            <th>Certificate Number</th>
            <th>Total Amount</th>
            <th>Amount Requested</th>
            <th>Approved Amount</th>
            <th>WHT Rate</th>
            <th>Amount Available</th>
            <th>Balance</th>
            <th>Swift No</th>
            <th>Certificate Issue Date</th>
            <th>Certificate Expiry Date</th>
            <th>Certificate Effective Date</th>
            <th>Status</th>
            <th>Currency</th>
            <th>Date</th>
            <th width={"9%"} data-orderable="false">
              Action
            </th>
          </tr>
        </thead>
        <tbody></tbody>
      </DataTableWrapper>
    </CertificateWrapper>
  );
}
